import React, { createContext, useContext, useEffect, useState } from 'react';

const DepartmentContext = createContext(null);

// iter318 — the global context is now the TRADE (db.inv_departments id) or 'all'.
const STORAGE_KEY = 'nexflow.activeTrade';

export const DepartmentProvider = ({ children }) => {
  const [activeDepartment, setActiveDepartmentState] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || 'all'; } catch { return 'all'; }
  });

  const setActiveDepartment = (d) => {
    setActiveDepartmentState(d);
    try { localStorage.setItem(STORAGE_KEY, d); } catch { /* ignore */ }
  };

  useEffect(() => {
    // Keep storage and state in sync across tabs
    const handler = (e) => {
      if (e.key === STORAGE_KEY && e.newValue) setActiveDepartmentState(e.newValue);
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  return (
    <DepartmentContext.Provider value={{ activeDepartment, setActiveDepartment }}>
      {children}
    </DepartmentContext.Provider>
  );
};

export const useDepartment = () => {
  const ctx = useContext(DepartmentContext);
  if (!ctx) return { activeDepartment: 'all', setActiveDepartment: () => {} };
  return ctx;
};

export const DEPARTMENT_OPTIONS = [
  { value: 'all', label: 'All Trades' },
  { value: 'service', label: 'Service' },
  { value: 'new_construction', label: 'New Construction' },
  { value: 'office', label: 'Office' },
];
